export default __webpack_public_path__ + "static/Hidrometro-6d6399e67ce2d4b3cb958e1ed181839b.svg";